const snippets = [
    {
        type: "cmd",
        label: "\\verb||",
        snippet: "\\verb|#{}|",
    },
];

export default snippets;
